export type DealStatus = 'new' | 'in_progress' | 'closed_won' | 'closed_lost' | 'on_hold'

const STATUS_CONFIG: Record<DealStatus, { label: string; className: string }> = {
  new:         { label: 'New',          className: 'bg-blue-100 text-blue-800' },
  in_progress: { label: 'In Progress',  className: 'bg-yellow-100 text-yellow-800' },
  closed_won:  { label: 'Closed Won',   className: 'bg-green-100 text-green-800' },
  closed_lost: { label: 'Closed Lost',  className: 'bg-red-100 text-red-800' },
  on_hold:     { label: 'On Hold',      className: 'bg-gray-100 text-gray-700' },
}

export function DealStatusBadge({ status }: { status: DealStatus }) {
  const config = STATUS_CONFIG[status] ?? STATUS_CONFIG.new
  return (
    <span className={`inline-flex items-center px-2 py-0.5 rounded text-xs font-medium ${config.className}`}>
      {config.label}
    </span>
  )
}
